export default __webpack_public_path__ + "static/media/06_Auctioneers-Commercial-EschweilerPhotography_M1A0372.2b852f1d.jpg";